import React from "react";
import { Redirect } from 'react-router-dom';

const NotFoundRedirect = () => {
    return <Redirect to="/404"/>
};
export default NotFoundRedirect;